export default function generateUserInitials(userName = '') {
  const splitUsername = userName.split(' ');
  const firstInitial = splitUsername[0]?.substr(0, 1);
  const lastInitial = splitUsername[splitUsername.length - 1]?.substr(0, 1);

  return `${firstInitial}${lastInitial}`.toUpperCase();
}
